import { getTheme, ITextStyles, Stack, Text } from '@fluentui/react';
import React from 'react';
import { numericalSpacingStackTokens, titleTextWrapperStyle, textWrapperStyle } from './SettingsStyles';

interface FieldSectionComponentProps {
  title: string;
  id?: string;
  titleAs?: React.ElementType<React.HTMLAttributes<HTMLElement>>;
  body?: string;
}

export const FieldSectionComponent: React.FC<FieldSectionComponentProps> = props => {
  const { palette } = getTheme();

  const SLATitleStyle: ITextStyles = {
    root: {
      color: palette.black
    }
  };

  const textStyle: ITextStyles = {
    root: {
      color: palette.neutralDark
    }
  };

  return (
    <div className="mb-3 ">
      <Stack horizontal horizontalAlign="space-between" tokens={numericalSpacingStackTokens}>
        <Stack styles={titleTextWrapperStyle} tokens={{ childrenGap: 5 }}>
          <Stack.Item>
            <Text
              as={props.titleAs}
              id={props.id}
              className="ms-sm12 ms-md12 font-weight-bold"
              role={'heading'}
              aria-level={2}
              variant={'mediumPlus'}
              styles={SLATitleStyle}
            >
              {props.title}
            </Text>
          </Stack.Item>
          {props.body && (
            <Stack.Item styles={textWrapperStyle}>
              <Text className="ms-sm12 ms-md12" variant={'medium'} styles={textStyle}>
                {props.body}
              </Text>
            </Stack.Item>
          )}
        </Stack>
        <Stack
          styles={{
            root: {
              marginTop: 5,
              display: 'flex',
              flexFlow: 'unset',
              alignItems: 'center',
              width: 230
            }
          }}
          className="position-relative"
        >
          {props.children}
        </Stack>
      </Stack>
    </div>
  );
};
